import React from "react";

function ToX(value,add){
    return (((Math.round(value)/100)+add)).toFixed(1)+'X';
}
export default ToX